import ComplianceImage from '~/assets/images/compliance_thumbnail.png'

export function mappingHtmlToBodyVideos(value) {
  let data = value;
  if (data) {
    data["video_cod"] = "000000";
    data["video_titulo"] = " Compliance Concorrencial";
    data["video_id"] = "complianceConcorrencial";
    data["video_duracao"] = 1000;
    data["video_thumbnail"] = ComplianceImage;
    data["fileBase64"] = value.file;
    data["data_publicacao"] = value.creationDate;
    data["video_contador_visualizacoes"] = 1;
    data["video_inserted_at"] = value.creationDate;
    data["html"] = true;

    data["publico"] = [];
    data["tag"] = [];

  }
  return data;
}

export function indexHtmlInVideosByCreatedDate(videos, file) {
  const htmlCreatedAt = new Date(file.data_publicacao);
  let index = 0;

  for (var i=0; i<videos.length; i+=1) {
    const videosPublishedAt = new Date(videos[i].video_data_publicacao);
    if (htmlCreatedAt < videosPublishedAt) {
      index = i;
    }
  }
  return index;
}
